<template>
    <span>
        <v-card-title primary class="title" style="height:25%;width:100%; font-size: 16px !important; font-weight: bold;">{{title}}</v-card-title>
        <v-card-actions ref="chartContainer" style="height:120px;width:100%;padding-top:0px;">
            <highcharts v-if="load" style="height:100px; width:100%;" :options="optionsFinalized"></highcharts>
        </v-card-actions>
    </span>
</template>

<script>

    import {Chart} from 'highcharts-vue'
    import More from 'highcharts/highcharts-more'
    import Highcharts from 'highcharts'
    import Exporting from 'highcharts/modules/exporting'

    Exporting(Highcharts);

    More(Highcharts);

    export default {
        name: "ChartFrequentIssues",
        components: {
            highcharts: Chart
        },
        props: {
            active: Boolean,
            title: String,
            flat: Boolean,
            chartOptions: Object || {},
        },
        data: function () {
            return {
                load: false,
                chart: null
            }
        },
        computed: {
            optionsFinalized: function () {
                var tmp = this.chartOptions;

                tmp.credits = false;
                return tmp;
            }
        },
        methods: {
            onResize(event) {
                setTimeout(() => {
                    if (typeof this.$refs['chartContainer'] != 'undefined') {
                        this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
                        this.load = true;
                    }
                });
            },
        },
        created() {
            window.addEventListener('resize', this.onResize);
        },
        mounted() {
            setTimeout(() => {
                if (typeof this.$refs['chartContainer'] != 'undefined') {
                    this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
                    this.load = true;
                }
            });
        },
        watch: {
            active: function () {
                setTimeout(() => {
                    if (typeof this.$refs['chartContainer'] != 'undefined') {
                        this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
                        this.load = true;
                    }
                });
            },
            chartOptions: function () {
                setTimeout(() => {
                    if (typeof this.$refs['chartContainer'] != 'undefined') {
                        this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
                        this.load = true;
                    }
                });
            }
        }
    }
</script>

<style scoped>
</style>
